import { Button } from "devextreme-react";
import {useProximaFichaDados} from "../../../../../Context/ProximaFichaDados"
import DropDownButton from 'devextreme-react/drop-down-button';
import "./style.css"

const ProximaFicha = (props) => {
    const {proximaFichaDados, setProximaFichaDados} = useProximaFichaDados()

    const arrayItensButtom = [
        {
            id: 1,
            name: 'Pesquisar contrato',
            functionName: 'pesquisarContrato'
        }
    ]

    const onItemClick = (item) => {
        if(item.itemData.functionName === 'pesquisarContrato'){
            //codigo para abrir o queryformpopup de titulo
            props.pesquisarContratoFunction()
        }
    }

    return(
        <div className="div-widget-telecob-proxima-ficha">
            {props.pesquisaFicha ? 
                (
                    <DropDownButton
                        splitButton={true}
                        useSelectMode={false}
                        text="Proxíma Ficha"
                        // icon="images/gym/coach-woman.png"
                        items={arrayItensButtom}
                        displayExpr="name"
                        keyExpr="id"
                        type="default"
                        height={40}
                        width={160}
                        onButtonClick={props.proximaFichaButtonClick}
                        onItemClick={onItemClick}
                    />
                ) 
                : 
                (
                    <Button
                        text="Proxíma Ficha"
                        onClick={props.proximaFichaButtonClick}
                        type="default"
                        height={40}
                    />
                )
            }
            

            
            {/* <Button
                text="teste"
                onClick={() => {console.log(proximaFichaDados)}}
                type="default"
                height={40}
            /> */}
            <div className="text-itens-proxima-ficha">
                <div><b>Fila:</b> {proximaFichaDados.nomeFilaAtual}</div>
                
                <div><b>Regra:</b> {proximaFichaDados.nomeRegraAtual}</div>
            </div>
        </div>
    )
}

export default ProximaFicha;